export enum WORKER_STATUS {
  ACTIVE = 'ACTIVE',
  NOT_INVITED = 'NOT_INVITED',
  SUSPENDED = 'SUSPENDED',
}
